export default {
    url: '/courses',
    template: '<search-courses/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/search/courses/index.js